import React from 'react'

function UserWallet() {
  return (
    <div>UserWallet</div>
  )
}

export default UserWallet